(() => {
  class FilterCollection extends HTMLElement {
    constructor() {
      super();
      this.filters = this.querySelectorAll("filter-search-custom");
      this.selectedFilters = [];

      this.filterDelete = this.querySelector(".js-filter-collection__delete");
    }

    connectedCallback() {
      this.addEventListener("filterUpdate", () => {
        this.collectFilters();

        const eventFilterCollection = new CustomEvent(
          "filterCollectionUpdate",
          {
            bubbles: true,
            detail: this.selectedFilters,
          }
        );
        this.dispatchEvent(eventFilterCollection);
      });

      this.collectFilters();

      this.filterDelete.addEventListener("click", () => {
        this.filterDelete.classList.add("hidden");
      });
    }

    collectFilters() {
      this.selectedFilters = [];

      this.filters.forEach((filter) => {
        this.selectedFilters = this.selectedFilters.concat(
          filter.getFilterURLs()
        );
      });

      if (this.selectedFilters.length !== 0) {
        this.filterDelete.classList.remove("hidden");
      } else {
        this.filterDelete.classList.add("hidden");
      }
    }
  }

  if (!customElements.get("filter-collection")) {
    customElements.define("filter-collection", FilterCollection);
  }
})();
